import { render, staticRenderFns } from "./ChatWithBusiness.vue?vue&type=template&id=1dbad9c9&"
import script from "./ChatWithBusiness.vue?vue&type=script&lang=js&"
export * from "./ChatWithBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports